<div class="releve-compte">
  <div class="date-filter-container mb-0" style="margin: 0 24px">
    <div class="date-filter-header" >
      <div class="date-nav-section">
        <p class="date-display date-label" *ngIf="viewMode === 'annees'">Année : {{ selectedYear }}</p>
        <ng-container *ngIf="viewMode !== 'annees'">
          <p class="date-display date-label">Mois : {{ monthLabel }} {{ selectedYear }}</p>
          <p class="date-display date-range">{{ periodShort }}</p>
        </ng-container>
      </div>
      <div class="date-filter-buttons-wrap">
        <div class="date-filter-buttons calendar-wrapper">
          <button type="button" class="btn calendar-btn-blue" (click)="openCalendarOnly(); $event.preventDefault()" aria-label="Ouvrir le calendrier">
            <i data-feather="calendar" class="calendar-icon"></i>
          </button>
          <input type="text" #datePicker class="flatpickr-input-releve" />
          <button type="button" class="btn btn-period" [class.active]="showPeriodPopup === 'jours'" (click)="openPeriodPopup('jours')">Jours</button>
          <button type="button" class="btn btn-period" [class.active]="showPeriodPopup === 'mois'" (click)="openPeriodPopup('mois')">Mois</button>
          <button type="button" class="btn btn-period" [class.active]="showPeriodPopup === 'annees'" (click)="openPeriodPopup('annees')">Année</button>
        </div>
        <div class="period-popup-wrapper" *ngIf="showPeriodPopup" (click)="closePeriodPopup()">
          <div class="period-popup shadow rounded" (click)="$event.stopPropagation()">
            <div *ngIf="showPeriodPopup === 'jours'" class="period-popup-content period-popup-jours">
              <div class="period-popup-title">Jours de la semaine</div>
              <div class="week-days-grid">
                <button *ngFor="let day of weekDaysForPopup" type="button" class="week-day-btn"
                        [class.today]="day.isToday"
                        [class.selected]="day.dateString === selectedDayDateString"
                        (click)="selectDayInPopup(day)">
                  <span class="day-name">{{ day.dayName }}</span>
                  <span class="day-date">{{ day.label }}</span>
                </button>
              </div>
            </div>
            <div *ngIf="showPeriodPopup === 'mois'" class="period-popup-content period-popup-mois">
              <div class="period-popup-mois-header">
                <span class="period-popup-year">{{ selectedYear }}</span>
                <div class="period-popup-year-nav">
                  <button type="button" class="btn-year-nav" (click)="changeYearInMonthPopup(-1)" aria-label="Année précédente">&lt;</button>
                  <button type="button" class="btn-year-nav" (click)="changeYearInMonthPopup(1)" aria-label="Année suivante">&gt;</button>
                </div>
              </div>
              <div class="months-grid-popup">
                <button *ngFor="let m of monthsShort; let i = index" type="button" class="month-btn-popup"
                        [class.selected]="i === selectedMonthIndex"
                        (click)="selectMonthInPopup(i)">
                  {{ m }}
                </button>
              </div>
            </div>
          <div *ngIf="showPeriodPopup === 'annees'" class="period-popup-content period-popup-annees">
            <div class="period-popup-title">Année</div>
            <div class="years-list-popup">
              <button *ngFor="let y of years" type="button" class="year-btn-popup"
                      [class.selected]="y === selectedYear"
                      (click)="selectYearInPopup(y)">
                {{ y }}
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card releve-outer-card rounded">
    <div>
    <div class="releve-content-wrapper">
        <div class=" releve-inner-card rounded">
            <div style="padding: 32px">
                <div class="releve-block releve-block-header">
                    <div class="releve-block-left">
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <div class="logo-v-placeholder logo-entreprise-wrap" style="margin-right: 10px">
                                <img *ngIf="stationData.logo" [src]="stationData.logo" alt="Logo" class="logo-entreprise-img" />
                                <span *ngIf="!stationData.logo" class="logo-v">V</span>
                            </div>
                            <span class="entreprise-name">{{ stationData.nom_entreprise || companyName }}</span>
                        </div>
                        <p class="entreprise-contact mb-0 ">{{ companyAddress }}</p>
                        <p class="entreprise-phones  mb-0">{{ companyPhones }}</p>
                    </div>
                    <div class="releve-block-right text-end">
                        <h5 class="releve-title mb-2">Relevé du compte</h5>
                        <p class="mb-0 statement-dates">Du : {{ dateDu }}</p>
                        <p class="mb-0 statement-dates">Au : {{ dateAu }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="releve-block releve-block-client">
            <div class="releve-block-left" style="margin-left: 12px">
                <p class="client-line" style="margin-bottom: 4px"><strong>Fournisseur:</strong><span style="color: rgba(47, 43, 61, 0.7)"> {{ fournisseurName }}</span>
                <p class="client-address mb-0 small" >{{ fournisseurAddress }}</p>
            </div>
            <div class="releve-block-right">
                <div class="soldes-inline">
                    <div class="solde-item">
                        <span class="solde-label">Solde initial :</span>
                        <span class="solde-value">{{ soldeInitialFormatted }} TND</span>
                    </div>
                    <div class="solde-item">
                        <span class="solde-label">Solde :</span>
                        <span class="solde-value">{{ soldeFormatted }} TND</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="releve-block releve-block-table">
            <div class="table-responsive">
                <table class="table releve-table mb-0">
                    <thead>
                    <tr>

                        <th>DATE</th>
                        <th>TRANSACTIONS</th>
                        <th>DÉTAILS</th>
                        <th>CRÉDIT</th>
                        <th>DÉBIT</th>
                        <th>SOLDE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="transactions.length === 0">
                        <td colspan="7" class="text-center text-muted py-4">Aucune transaction</td>
                    </tr>
                    <tr *ngFor="let t of paginatedTransactions; let i = index" [class.row-even]="i % 2 === 1">

                        <td>{{ t.date }}</td>
                        <td>{{ t.transaction }}</td>
                        <td>{{ t.details }}</td>
                        <td>{{ t.credit }}</td>
                        <td>{{ t.debit }}</td>
                        <td>{{ t.solde }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="row d-flex releve-pagination-row align-items-center" *ngIf="transactions.length > 0">
                <div class="col-md-6 col-12">
                    <div class="d-flex align-items-center flex-wrap releve-pagination-label">
                        <span class="text-muted me-2">Afficher</span>
                        <select class="form-control form-control-sm mx-1" style="width: auto;"
                                [(ngModel)]="pageSize" (ngModelChange)="currentPage = 1; updatePagination()">
                            <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
                        </select>
                        <span class="text-muted ms-2 releve-pagination-info">
                            Lignes {{ paginationStartIndex }} à {{ paginationEndIndex }} sur {{ transactions.length }}
                        </span>
                    </div>
                </div>
                <div class="col-md-6 col-12 text-end mt-2 mt-md-0">
                    <div class="d-flex flex-wrap justify-content-end gap-1 releve-pagination-buttons">
                        <button type="button" class="page-box" [class.disabled]="currentPage === 1"
                                [disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)" aria-label="Première page">«</button>
                        <button type="button" class="page-box" [class.disabled]="currentPage === 1"
                                [disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(currentPage - 1)" aria-label="Page précédente">‹</button>
                        <button *ngFor="let page of pages" type="button" class="page-box" [class.active]="page === currentPage"
                                (click)="changePage(page)">{{ page }}</button>
                        <button type="button" class="page-box" [class.disabled]="currentPage === totalPages"
                                [disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(currentPage + 1)" aria-label="Page suivante">›</button>
                        <button type="button" class="page-box" [class.disabled]="currentPage === totalPages"
                                [disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(totalPages)" aria-label="Dernière page">»</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</div>
